export default import.meta.ROLLDOWN_FILE_URL_0qan2GL7_ec$EbvoOAG3kQ